import { PermissionsObject } from "../generated/graphql";

interface ICheckPermissions {
  userPermissions?: PermissionsObject;
  permissions: {
    key: keyof PermissionsObject;
    isComparison?: boolean;
    a?: string | number | boolean | null;
    b?: string | number | boolean | null;
  }[];
  isAny?: boolean;
}

const checkPermissions = ({
  userPermissions,
  permissions,
  isAny,
}: ICheckPermissions) => {
  if (!userPermissions) {
    return false;
  }

  if (!permissions || !permissions.length) {
    return true;
  }

  let hasAccess = isAny ? false : true;

  for (let permission of permissions) {
    const { key, isComparison, a, b } = permission;

    const currentValue = userPermissions[key];

    if (currentValue) {
      if (isComparison) {
        if (a === b) {
          if (isAny) {
            hasAccess = true;
            break;
          }
        } else if (!isAny) {
          hasAccess = false;
          break;
        }
      } else if (isAny) {
        hasAccess = true;
        break;
      }
    } else if (!isAny) {
      hasAccess = false;
      break;
    }
  }

  return hasAccess ? true : false;
};

export default checkPermissions;
